import React from "react";
// import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-primary-darker text-white text-sm">
      <div className="container mx-auto px-6 py-10 text-center lg:text-left">
        <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start gap-8">
          {/* Firm Info */}
          <div className="flex-1">
            <h3 className="text-xl font-semibold mb-2 text-accent">
              Cire Legal, LLC
            </h3>
            <p className="text-gray-300 mb-4 max-w-sm mx-auto lg:mx-0">
              A boutique law firm supporting entrepreneurs, athletes, and
              individuals in business law, trademark protection, NIL strategy,
              and personal injury matters.
            </p>
            <p className="text-gray-400 text-xs">
              2025 &copy; Cire Legal, LLC. All rights reserved.
            </p>
          </div>

          {/* Quick Links */}
          <div className="max-w-[380px] text-center lg:text-center">
            <h4 className="text-lg font-semibold mb-2 text-accent">
              Quick Links
            </h4>
            <ul className="space-y-1">
              <li>
                <a href="#home" className="hover:text-accent">
                  Home
                </a>
              </li>
              <li>
                <a href="#about" className="hover:text-accent">
                  About
                </a>
              </li>
              <li>
                <a href="#service" className="hover:text-accent">
                  Services
                </a>
              </li>
              <li>
                <a
                  href="https://calendar.app.google/NkmTwF6Q78A5GLbr7"
                  className="hover:text-accent"
                >
                  Schedule a Consultation
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="lg:ml-[300px]   /* moves right on desktop */ ">
            <h4 className="text-lg font-semibold mb-2 text-accent">Contact</h4>
            <ul className="space-y-1">
              <li>
                Email:{" "}
                <a
                  href="mailto:info@cirelegal.com"
                  className="hover:text-accent"
                >
                  attorney@cirelegal.com
                </a>
              </li>
              <li>
                Phone:{" "}
                <a href="tel:+14706321573" className="hover:text-accent">
                  (470) 632-1573
                </a>
              </li>
              <li>Atlanta, GA</li>
            </ul>
            {/* Social Media */}
            {/* <div className="flex justify-center lg:justify-start gap-4 mt-4 text-xl">
              <a href="#" className="hover:text-accent">
                <FaFacebook />
              </a>
              <a href="#" className="hover:text-accent">
                <FaInstagram />
              </a>
              <a href="#" className="hover:text-accent">
                <FaLinkedin />
              </a>
            </div> */}
          </div>
        </div>
        {/* Divider */}
        <div className="border-t border-gray-700 mt-8 pt-4 text-center text-gray-400 text-xs">
          <p>
            Site design & development by
            <span className="text-accent font-semibold"> Phillippe Louis</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
